import React, { useCallback, useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckIcon, PawIcon } from './Icons';
interface Notification {
  name: string;
  location: string;
  timeAgo: string;
}
const notifications: Notification[] = [{
  name: 'Maria R.',
  location: 'Austin, TX',
  timeAgo: '2 minutes ago'
}, {
  name: 'James K.',
  location: 'Denver, CO',
  timeAgo: '5 minutes ago'
}, {
  name: 'Sarah L.',
  location: 'Portland, OR',
  timeAgo: '8 minutes ago'
}, {
  name: 'Michael T.',
  location: 'Nashville, TN',
  timeAgo: '11 minutes ago'
}, {
  name: 'Amanda W.',
  location: 'Charlotte, NC',
  timeAgo: '14 minutes ago'
}, {
  name: 'David P.',
  location: 'Phoenix, AZ',
  timeAgo: '17 minutes ago'
}, {
  name: 'Jessica M.',
  location: 'Atlanta, GA',
  timeAgo: '22 minutes ago'
}, {
  name: 'Chris B.',
  location: 'San Diego, CA',
  timeAgo: '26 minutes ago'
}, {
  name: 'Lauren H.',
  location: 'Raleigh, NC',
  timeAgo: '31 minutes ago'
}, {
  name: 'Ryan S.',
  location: 'Tampa, FL',
  timeAgo: '35 minutes ago'
}, {
  name: 'Emily D.',
  location: 'Columbus, OH',
  timeAgo: '40 minutes ago'
}, {
  name: 'Brandon F.',
  location: 'Dallas, TX',
  timeAgo: '47 minutes ago'
}];
export function SocialProofPopup() {
  const [visible, setVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [dismissed, setDismissed] = useState(false);
  const showNext = useCallback(() => {
    if (dismissed) return;
    setCurrentIndex(prev => (prev + 1) % notifications.length);
    setVisible(true);
    setTimeout(() => {
      setVisible(false);
    }, 4500);
  }, [dismissed]);
  useEffect(() => {
    if (dismissed) return;
    // First popup after 8 seconds
    const initialTimer = setTimeout(() => {
      setVisible(true);
      setTimeout(() => setVisible(false), 4500);
    }, 8000);
    // Subsequent popups every 18-28 seconds
    const interval = setInterval(() => {
      showNext();
    }, Math.random() * 10000 + 18000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, [dismissed, showNext]);
  if (dismissed) return null;
  const current = notifications[currentIndex];
  return <div className="fixed bottom-4 left-4 z-40 max-w-xs sm:max-w-sm" aria-live="polite" data-id="element-309">
      <AnimatePresence data-id="element-310">
        {visible && <motion.div initial={{
        opacity: 0,
        x: -80,
        y: 10
      }} animate={{
        opacity: 1,
        x: 0,
        y: 0
      }} exit={{
        opacity: 0,
        x: -80,
        y: 10
      }} transition={{
        type: 'spring',
        stiffness: 300,
        damping: 28
      }} className="relative bg-bg-card border border-white/10 rounded-xl p-4 pr-9 shadow-2xl shadow-black/40" data-id="element-311">
            {/* Close button */}
            <button onClick={() => {
          setVisible(false);
          setDismissed(true);
        }} className="absolute top-2 right-2 w-5 h-5 flex items-center justify-center text-cream-muted/50 hover:text-cream-muted transition-colors" aria-label="Dismiss notifications" data-id="element-312">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-3.5 h-3.5" data-id="element-313">
                <line x1="18" y1="6" x2="6" y2="18" data-id="element-314" />
                <line x1="6" y1="6" x2="18" y2="18" data-id="element-315" />
              </svg>
            </button>

            <div className="flex items-center gap-3" data-id="element-316">
              {/* Icon */}
              <div className="flex-shrink-0 w-10 h-10 rounded-full bg-green-deep/30 border border-green-accent/20 flex items-center justify-center" data-id="element-317">
                <PawIcon className="w-5 h-5 text-green-accent" data-id="element-318" />
              </div>

              {/* Content */}
              <div className="min-w-0" data-id="element-319">
                <p className="font-sans text-sm text-cream leading-snug" data-id="element-320">
                  <span className="font-semibold" data-id="element-321">{current.name}</span>{' '}
                  <span className="text-cream-muted" data-id="element-322">from</span>{' '}
                  <span className="font-medium" data-id="element-323">{current.location}</span>
                </p>
                <p className="font-sans text-xs text-gold mt-0.5 flex items-center gap-1" data-id="element-324">
                  <CheckIcon className="w-3 h-3" data-id="element-325" />
                  just got the bundle
                </p>
                <p className="font-sans text-[10px] text-cream-muted/50 mt-0.5" data-id="element-326">
                  {current.timeAgo}
                </p>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}